import BaseService from "src/packages/BaseService";

export default class TagService extends BaseService {
	static get className() {
		return "tag";
	}
};
